<template>
  <b-form-select
    v-model="valueForm"
    :options="options"
    :state="validateState('tipo_instituicao_id')"
  ></b-form-select>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

import { mapActions } from "vuex";
import { map } from "lodash";

export default {
  mixins: [validationMixin],
  data: () => ({
    instituicoes: [],
  }),
  props: {
    value: {},
  },
  validations: {
    value: {
      tipo_instituicao_id: {
        required,
        minLength: minLength(1),
      },
    },
  },
  computed: {
    options() {
      return map(this.instituicoes, function (obj) {
        return {
          text: obj.nome,
          value: obj.id,
        };
      });
    },
    valueForm: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("tipos_instituicoes", ["ActionFind"]),
    validateState(name) {
      const { $dirty, $error } = this.$v.value[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.value.$touch();
      return !this.$v.value.$anyError;
    },
  },
  async created() {
    let response = await this.ActionFind({ per_page: 100 });
    this.instituicoes = response.data;

  },
};
</script>

<style></style>
